class SharePatient {
  constructor(params) {
    this.id = params.patientId;
    this.requestId = params.requestId;
    [this.lastName, this.firstName] = params.patientName.split(', ');
  }
}

export { SharePatient };
